module.exports = __webpack_public_path__ + "img/owner2.238806e4.jpg";